import React, { useState } from 'react'
import { handleKeyDown } from '@/utils/functions/handleKeyDown'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'

import PropTypes from 'prop-types'
import { STextField } from './styles'

import s from './styles.module.scss'

const CaluRawInput = ({ labelText, countryCode, enterToSubmit = false, type, ...rest }) => {
  const height = rest.multiline ? 'auto' : '48px'
  const isPasswordType = type === 'password'
  const [showPassword, setShowPassword] = useState(false)

  const handleToggleVisibility = () => setShowPassword((prev) => !prev)

  return (
    <div>
      {labelText && <div className={s.titleInput}>{labelText}</div>}
      <div className={`${s.defaultStyles} ${rest.className}`} style={{ height }}>
        <STextField
          type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
          InputProps={{
            startAdornment: countryCode ? <InputAdornment position="start">{`+${countryCode}`}</InputAdornment> : null,
            endAdornment: isPasswordType && (
              <InputAdornment position="end">
                <IconButton onClick={handleToggleVisibility} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            classes: {
              notchedOutline: s.notchedOutline,
            },
          }}
          inputProps={{
            maxLength: rest.maxLength,
          }}
          onWheel={(e) => e.target.blur()}
          helperText={rest?.error && rest.helperText}
          onKeyDown={enterToSubmit ? null : handleKeyDown}
          {...rest}
        />
      </div>
    </div>
  )
}

export default CaluRawInput

CaluRawInput.propTypes = {
  type: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  labelText: PropTypes.string,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  maxRows: PropTypes.number,
  maxLength: PropTypes.number,
}
